import React from 'react';
import './RoomDetailsModal.css';

const RoomDetailsModal = ({ room, onClose, onJoinEntity }) => {
    if (!room) return null;

    const isEvent = room.isEvent;
    const isGroup = room.roomType === 'group' || !!room.group_id;
    const bannerUrl = room.event_banner_url || room.room_banner_url || null;

    return (
        <div className="room-details-modal-overlay" onClick={onClose}>
            <div className="room-details-modal" onClick={e => e.stopPropagation()}>
                <button className="rdm-close-btn" onClick={onClose}>×</button>

                {bannerUrl && (
                    <div className="rdm-banner">
                        <img src={bannerUrl} alt={room.name} />
                    </div>
                )}

                <div className="rdm-content">
                    <h2 className="rdm-title">{room.name}</h2>

                    <div className="rdm-meta-grid">
                        {room.language && (
                          <div className="rdm-meta-item">
                              <span className="rdm-label">Language</span>
                              <span className="rdm-value">{room.language}</span>
                          </div>
                        )}
                        {room.level && (
                            <div className="rdm-meta-item">
                                <span className="rdm-label">Level</span>
                                <span className="rdm-value">{room.level}</span>
                            </div>
                        )}
                        {room.native_language && (
                          <div className="rdm-meta-item">
                              <span className="rdm-label">Native Language</span>
                              <span className="rdm-value">{room.native_language}</span>
                          </div>
                        )}
                        {isEvent && (
                            <>
                                <div className="rdm-meta-item">
                                    <span className="rdm-label">Date</span>
                                    <span className="rdm-value">{room.date}</span>
                                </div>
                                <div className="rdm-meta-item">
                                    <span className="rdm-label">Time</span>
                                    <span className="rdm-value">{room.time}</span>
                                </div>
                            </>
                        )}
                    </div>

                    {(room.description || room.topic) && (
                        <div className="rdm-description">
                            <h3>About</h3>
                            <p>{room.description || room.topic}</p>
                        </div>
                    )}

                    <div className="rdm-actions">
                        <button className="rdm-cta-btn" onClick={() => onJoinEntity(room)}>
                            {isEvent ? 'Go to Event Page' : isGroup ? 'Go to Group Page' : 'Join Room'}
                        </button>
                        <button className="rdm-cancel-btn" onClick={onClose}>Close</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RoomDetailsModal;
